import React from 'react';
import { Terminal, ChevronDown, ChevronUp, FileText } from 'lucide-react';
import TerminalView from './TerminalView';
import LogsView from './LogsView';

const DevToolsDrawer = ({ 
  isOpen, 
  onToggle,
  selectedTab,
  onTabChange,
  logs,
  logRef,
  terminalTabs,
  activeTerminalTab,
  setActiveTerminalTab,
  setTerminalTabs,
  agentStatus,
  terminalRef
}) => {
  return (
    <div 
      className={`absolute bottom-0 left-0 right-0 ${isOpen ? 'bg-white dark:bg-neutral-900 border-t border-neutral-200 dark:border-neutral-800' : ''} rounded-b-2xl transition-all duration-300 ease-in-out z-20`}
      style={{ 
        height: isOpen ? '50%' : '0',
        boxShadow: isOpen ? '0 -2px 10px rgba(0, 0, 0, 0.1)' : 'none'
      }}
    >
      {/* Drawer Tab */}
      <button
        className="absolute -top-9 left-1/2 transform -translate-x-1/2 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 border-b-0 rounded-t-lg px-4 py-1.5 flex items-center space-x-2 text-sm font-medium text-ui-text-primary hover:bg-neutral-50 dark:hover:bg-neutral-800 transition-colors shadow-sm z-30"
        onClick={onToggle}
      >
        <Terminal size={14} />
        <span>Dev Tools</span>
        {isOpen ? <ChevronDown size={14} /> : <ChevronUp size={14} />}
      </button>
      
      {/* Drawer Content */}
      <div className={`flex flex-col h-full ${isOpen ? '' : 'hidden'}`}>
        {/* Tab Headers */}
        <div className="bg-slate-300 dark:bg-neutral-800 flex w-full mt-1">
          <button 
            className={`flex-1 px-3 py-1.5 flex items-center justify-center text-sm font-semibold ${selectedTab === 'terminal' ? 'relative text-ui-text-primary' : 'text-ui-text-secondary hover:text-ui-text-primary'}`}
            onClick={() => onTabChange('terminal')}
            data-tour="terminal-tab"
          >
            <Terminal size={14} className="mr-1.5" />
            Terminal
            {selectedTab === 'terminal' && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[80%] max-w-[80%] h-0.5 bg-brand-primary"></div>}
          </button>
          <button 
            className={`flex-1 px-3 py-1.5 flex items-center justify-center text-sm font-semibold ${selectedTab === 'logs' ? 'relative text-ui-text-primary' : 'text-ui-text-secondary hover:text-ui-text-primary'}`}
            onClick={() => onTabChange('logs')}
            data-tour="logs-tab"
          >
            <FileText size={14} className="mr-1.5" />
            Logs
            {selectedTab === 'logs' && <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-[80%] max-w-[80%] h-0.5 bg-brand-primary"></div>}
          </button>
        </div>
        
        {/* Tab Content */}
        <div className="flex-1 h-full bg-slate-100 dark:bg-neutral-900 overflow-hidden">
          {selectedTab === 'logs' && <LogsView logs={logs} logRef={logRef} />}
          {selectedTab === 'terminal' && (
            <TerminalView 
              terminalTabs={terminalTabs}
              activeTerminalTab={activeTerminalTab}
              setActiveTerminalTab={setActiveTerminalTab}
              setTerminalTabs={setTerminalTabs}
              agentStatus={agentStatus}
              terminalRef={terminalRef}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DevToolsDrawer; 